import * as React from 'react';
import { MergeUserContainerProps } from 'app/area/administration/shared/merge-user/types';
import { MergeUserModal } from 'app/area/administration/shared/merge-user/merge-user-modal';

export const MergeUserContainer = (props: MergeUserContainerProps) => {

  const {
    mergeUser, updateMergeUser, translation, validation, userOptions, loadOptions, resetValidation
  } = props;

  const deleteMergeUserItem = (uncheckSelectItem: boolean) => {
    const { mergeUser: { id, reassignReferencesToUser: { value = undefined } = {} }, deleteMergeUser } = props;

    deleteMergeUser({
      id,
      ...(!uncheckSelectItem && { reassignReferencesToUser: value }),
      successMessage: translation.user_successfully_deleted
    });
  };

  const onClose = () => updateMergeUser({ ...mergeUser, showMergeUser: false });


  return mergeUser?.showMergeUser
    && <MergeUserModal
      mergeUser={mergeUser}
      updateMergeUser={updateMergeUser}
      options={userOptions}
      loadOptions={loadOptions}
      translation={translation}
      validation={validation}
      deleteMergeUserItem={deleteMergeUserItem}
      onClose={onClose}
      resetValidation={resetValidation} />;
};
